// extracted by mini-css-extract-plugin
export default {"c-wrapper":"index-module--c-wrapper--fAcKH","c-content":"index-module--c-content--csXKh"};